import { SummaryView } from '../../components/summary-view/summary-view.component';
import { MESSAGES_ALERT } from './constants/messages-alerts';

export const DataConfirmation = () => {
	return <SummaryView alertDescription={MESSAGES_ALERT.ALERT} />;
};
